import { render, staticRenderFns } from "./tabIndex.vue?vue&type=template&id=2d4f434a&scoped=true&"
import script from "./tabIndex.vue?vue&type=script&lang=js&"
export * from "./tabIndex.vue?vue&type=script&lang=js&"
import style0 from "./tabIndex.vue?vue&type=style&index=0&id=2d4f434a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4f434a",
  null
  
)

export default component.exports